module.exports = __webpack_public_path__ + "images/usermodule/_04.png";


//////////////////
// WEBPACK FOOTER
// ./images/usermodule/_04.png
// module id = 1527
// module chunks = 4